import { render, staticRenderFns } from "./EditWx.vue?vue&type=template&id=0aed31db&scoped=true&"
import script from "./EditWx.vue?vue&type=script&lang=js&"
export * from "./EditWx.vue?vue&type=script&lang=js&"
import style0 from "./EditWx.vue?vue&type=style&index=0&id=0aed31db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aed31db",
  null
  
)

export default component.exports